import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";

// eslint-disable-next-line next-intl/only-next-intl-link
import { Link } from "@sikt/sds-core";
import { Footer } from "@sikt/sds-footer";
import { Logo } from "@sikt/sds-logo";
import PageContentContainer from "@/src/components/page-content-container/page-content-container";
import { Locale } from "@/src/intl/locale";
import "@/src/styles/globals.css";
import { WithChildren } from "@/src/types/generic-react-props";
import css from "./error-page-layout.module.css";
interface ErrorPageBodyProps extends WithChildren {
  locale: Locale;
}
const ErrorPageBody = t0 => {
  const $ = _c(12);
  const {
    children,
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("sds-header", css.header);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `/${locale}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Logo productName="Min kompetanse" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2) {
    t4 = <header className={t1}><nav><div className="sds-header__content"><Link className={css.logoLink} href={t2}>{t3}</Link></div></nav></header>;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = <PageContentContainer className={css.contentContainer}>{children}</PageContentContainer>;
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== locale) {
    t6 = <Footer lang={locale} className={css.footer} />;
    $[6] = locale;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <body className={css.errorPageContainer}>{t4}{t5}{t6}</body>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default ErrorPageBody;